const state= {
    Items:{
        data:[],
        total:0,
        pages: {
            isCMS: '1',
            page:1,
            totalPage : 1,
            limit:25,
            filter:{}
        },
    },
    Loadings:{
        list: false,
        detail: false,
    },
    Item: {},
};

const getters = {
    Items : (state) => state.Items,
    Loadings : (state) => state.Loadings,
    Item : (state) => state.Item,
};

const actions = {
    async getItems({commit}, params){
        commit( 'setLoadings', {key:"list",val:true});
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/gl-manual-entry`, {params:params})
            .then(response => {
                commit( 'setLoadings', {key:"list",val:false});
                response.data.data.pages = params
                commit( 'setListItems', response.data.data );
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    async getItem({commit}, params){
        commit( 'setLoadings', {key:"detail",val:true});
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/gl-manual-entry/${params.id}`)
            .then(response => {
                commit( 'setLoadings', {key:"detail",val:false});
                //commit( 'setItem', response.data.data );
                resolve( response );
            })
            .catch(error => {
                commit( 'setLoadings', {key:"detail",val:false});
                reject( error );
            });
        });
    },
    async createItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.post(`api/gl-manual-entry`, params)
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async updateItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.put(`api/gl-manual-entry/${params.id}`, params)
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async deleteItem({commit}, params) {
        return new Promise((resolve, reject) => {
            global.axios.delete(`/api/gl-manual-entry`, {
                data: params
            })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        })
    },
    async exportCsv({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`/api/gl-manual-entry/export`, {
                params: params,
                responseType: 'blob'
            })
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    /*line item*/
    async createGLLineItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.post(`api/gl-manual-item`, params)
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async updateGLLineItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.put(`api/gl-manual-item/${params.id}`, params)
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async getGLLineItems({commit}, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`/api/gl-manual-item`, {
                params: params
            })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async deleteGLLineItems({commit}, params) {
        return new Promise((resolve, reject) => {
            global.axios.delete(`/api/gl-manual-item`, {
                data:params
            })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        })
    },
};

const mutations = {
    setListItems (state,data) {
        data.pages.totalPage = Math.ceil(data.total / data.pages.limit )
        state.Items.data = data.items
        state.Items.total = data.total
        state.Items.pages = data.pages
    },
    setItem (state, data) {
        state.Item = data;
    },
    setLoadings (state,data) {
        state.Loadings[data.key] = data.val;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}